import { useContext } from "react";
import ProgressBar from "../../../components/progress-bar";
import { TransferContext } from "../../../context/TransferContext";

const ProgressBarController = () => {
  const { progressBar } = useContext(TransferContext);
  if (!progressBar.shouldShowProgressBar) {
    return null;
  }

  return <ProgressBar progress={progressBar.progress} />;
};

export default ProgressBarController;
